import React from 'react';

import Input from 'antd/es/input';
import Form from 'antd/es/form';
// import Switch from 'antd/es/switch';
import Select from 'antd/es/select';

import { Row, Col } from 'components/layout';

const { Option } = Select;

const CameraForm = ({ form, doorOptions }) => (
  <Form
    form={form}
    layout="vertical"
    hideRequiredMark={true}
    onFinish={form.onSubmit}
  >
    <Row gutter={[12]}>
      <Col span={12}>
        <Form.Item
          label="Camera name"
          name="name"
          rules={[
            {
              required: true,
              message: 'Camera name is required',
            },
          ]}
        >
          <Input placeholder="Enter camera name" />
        </Form.Item>
      </Col>
      <Col span={12}>
        <Form.Item
          label="IP"
          name="ip"
        >
          <Input placeholder="Enter IP" />
        </Form.Item>
      </Col>
      <Col span={12}>
        <Form.Item
          label="Mode"
          name="is_active"
          rules={[
            {
              required: true,
              message: 'Mode is required',
            },
          ]}
        >
          <Select placeholder="Select Mode">
            <Option value={0}>Not Responding</Option>
            <Option value={1}>Running</Option>
          </Select>
        </Form.Item>
      </Col>
      <Col span={12}>
        <Form.Item
          label="User"
          name="user"
        >
          <Input placeholder="Enter User" />
        </Form.Item>
      </Col>

      <Col span={12}>
        <Form.Item
          label="Brand"
          name="brand"
        >
          <Input placeholder="Enter Brand" />
        </Form.Item>
      </Col>
      <Col span={12}>
        <Form.Item
          label="Password"
          name="password"
        >
          <Input placeholder="Enter password" />
        </Form.Item>
      </Col>
      {/* <Col span={12}>
        <Form.Item
          label="Door ID"
          name="door_id"
          rules={[
            {
              required: true,
              message: 'Door ID is required',
            },
          ]}
        >
          <Input placeholder="Add Door ID" />
        </Form.Item>
      </Col> */}
      <Col span={12}>
        <Form.Item
          label="Door ID"
          name="door_id"
        >
          <Select options={doorOptions} placeholder="Select Door" />
        </Form.Item>
      </Col>

      <Col span={12}>
        <Form.Item
          label="Door Distance"
          name="door_distance"
        >
          <Input placeholder="Enter Door Distance" />
        </Form.Item>
      </Col>
      <Col span={12}>
        <Form.Item
          label="Zone Code"
          name="zone_code"
        >
          <Input placeholder="Enter Zone Code" />
        </Form.Item>
      </Col>
      <Col span={12}>
        <Form.Item
          label="Floor Height"
          name="floor_height"
        >
          <Input placeholder="Enter Floor Height" />
        </Form.Item>
      </Col>

      {/* <Col span={12}>
        <Form.Item
          label="Is Running"
          name="is_active"
          valuePropName="checked"
          normalize={checked => checked ? 1 : 0}
        >
          <Switch />
        </Form.Item>
      </Col> */}
    </Row>

  </Form>
);

export default CameraForm;